
           document.addEventListener('DOMContentLoaded', function () {
  
  // identify an element to observe
const elementToObserve = document.querySelector("#mini-cart");

// create a new instance of `MutationObserver` named `observer`,
// passing it a callback function
const observer = new MutationObserver(function() {
  fetchWithFor();
  
});

// call `observe()` on that MutationObserver instance,
// passing it the element to observe, and the options object
observer.observe(elementToObserve, {subtree: true, childList: true});

  
  }, false);
          


           document.addEventListener('DOMContentLoaded', function () {
  fetchWithFor();
  // identify an element to observe
const cartTemplateObserve = document.querySelector("#cart-template");

// create a new instance of `MutationObserver` named `observer`,
// passing it a callback function
const cartTemplateobserver = new MutationObserver(function() {
  fetchWithFor();
  
});

// call `observe()` on that MutationObserver instance,
// passing it the element to observe, and the options object
cartTemplateobserver.observe(cartTemplateObserve, {subtree: true, childList: true});


  
  }, false);
          

document.addEventListener('DOMContentLoaded', function () {
  
  const quantityDivsProductPage = document.getElementsByClassName('quantity-selector--product');
  for(i = 0; i < quantityDivsProductPage.length; i++) {
    quantityDivsProductPage[i].style.opacity = '1';
  }
             
  const quantityDivsCart = document.getElementsByClassName('quantity-selector');
  for(i = 0; i < quantityDivsCart.length; i++) {
    quantityDivsCart[i].style.opacity = '1';
  }
  
}, false);